import { KlaviyoAPI, registerEmailInKlaviyo } from '../services/klaviyo';
import { $Q, $Qll } from '../utils/querySelector';

(() => {
  /**
   *
   * modal elemen
   *
   * @type {HTMLDialogElement}
   */
  const modal = $Q('#bis-modal');

  /**
   *
   * modal submit button
   *
   * @type {HTMLButtonElement}
   */
  const submitButton = $Q('#bis-modal__action', modal);

  /**
   * Modal message element
   */
  const modalMessage = $Q('.bis-modal__message', modal);

  // bind modal close
  $Q('.bis-modal__close', modal).addEventListener('click', () => {
    modal.close();
    modalMessage.classList.add('hidden');
    submitButton.classList.remove('hidden');
  });

  modal.addEventListener('click', (e) => {
    if (e.target.tagName.toLowerCase() === 'dialog') {
      modal.close();
      modalMessage.classList.add('hidden');
      submitButton.classList.remove('hidden');
    }
  });

  // bind email input to the button's disabled state
  $Q('#bis-email', modal).addEventListener('input', (e) => {
    const email = e.target.value;

    if (email && /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/.test(email)) {
      submitButton.removeAttribute('disabled');
    } else {
      submitButton.setAttribute('disabled', true);
    }
  });

  // bind submit event to the form
  $Q('#bis-form', modal).addEventListener('submit', async (e) => {
    e.preventDefault();

    const variantId = $Q('#bis-variant-selector').value;
    const email = $Q('#bis-email').value;

    submitButton.classList.add('loading');
    registerEmailInKlaviyo(email);

    const response = await KlaviyoAPI.subscribeToBackInStock(email, variantId);

    modalMessage.classList.remove('hidden');
    if (response.status === 202) {
      modalMessage.innerHTML = modalMessage.dataset.successMessage;
      modalMessage.classList.add('success');
      submitButton.classList.add('hidden');
    } else {
      modalMessage.innerHTML = modalMessage.dataset.errorMessage;
      modalMessage.classList.add('error');
    }

    submitButton.classList.remove('loading');
  });

  /**
   *
   * @param {MouseEvent} event
   */
  const handleButtonClick = async (event, button) => {
    event.stopPropagation();
    event.preventDefault();
    const { productTitle } = button.dataset;
    const variants = JSON.parse(button.dataset.productVariants);

    // set the title
    $Q('.bis-modal__title', modal).textContent = productTitle;

    // render variants
    const fragment = document.createDocumentFragment();
    const fakeOption = document.createElement('option');
    variants.forEach((variant, index) => {
      const { id, title } = variant;

      const option = fakeOption.cloneNode();
      option.setAttribute('value', id);
      if (title.toLowerCase().includes('default')) {
        option.textContent = productTitle;
      } else {
        option.textContent = title;
      }

      if (index === 0) {
        option.setAttribute('selected', 'true');
      }
      fragment.appendChild(option);
    });

    const select = $Q('#bis-variant-selector', modal);
    select.innerHTML = '';
    select.appendChild(fragment);

    // show modal
    modal.showModal();
  };

  const registerEvents = () => {
    const buttons = $Qll('button[data-back-in-stock]:not([data-events])');

    buttons.forEach((button) => {
      button.addEventListener('click', function (e) {
        handleButtonClick(e, button)
      });
      button.setAttribute('data-events', 'registered');
    });

    // product card event binding
    const mainprodButton = $Q('#main-add-cart.klaviyo-bis-trigger');

    if (mainprodButton) {
      mainprodButton.addEventListener('click', function (e) {
        handleButtonClick(e, mainprodButton)
      });
    }

    // sticky add to cart event binding
    const stickyAddCartButton = $Q(
      '.stickyaddcart__buttons .klaviyo-bis-trigger'
    );

    if (stickyAddCartButton) {
      stickyAddCartButton.addEventListener('click', handleButtonClick);
    }
  };

  window.backInStockRegisterEvents = registerEvents;
  document.addEventListener('DOMContentLoaded', () => {
    registerEvents();
  });

  //
})();
